// extracted by mini-css-extract-plugin
export default {"magasinsTable":"users-table_magasinsTable__bRDp6","sortIcons":"users-table_sortIcons__xq1-5","active":"users-table_active__X-Hs7","name":"users-table_name__vB4FI"};